// Packages and componets
import { Button } from 'grommet';
import styled from 'styled-components';

// Helpers and utilities
import { colors } from '@theme/globals/colors';
import { Sizes } from '@theme/globals/sizing';
import { TypographySettings } from '@theme/globals/typography';

export const StyledAuthButton: typeof Button = styled(Button)`
  appearance: none;
  border-color: ${colors ? colors['gray-300'] : 'gray'};
  border-radius: ${Sizes[12]};
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  color: ${colors ? colors['gray-900'] : 'black'};
  font-family: ${TypographySettings['subhead-bold'].family};
  font-size: ${TypographySettings['subhead-bold'].size};
  font-weight: ${TypographySettings['button'].weight};
  line-height: ${TypographySettings['subhead-bold'].height};
  padding: ${Sizes[14]} ${Sizes[12]};
  width: 100%;
  &:focus {
    outline: none;
  }
  &:hover {
    box-shadow: none;
  }
`;
